import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { CostMode } from '../models';

import { API_FLEET_URL } from '@/utils';

import { RootState } from '@/store/store';

const costModesService = createApi({
  reducerPath: 'costModesService',
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_FLEET_URL}/costModes`,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState;

      const token = state.auth?.auth?.accessToken || null;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getCostModes: builder.query<CostMode[], void>({
      query: () => '',
      transformResponse: (response: { items: CostMode[] }) => response.items,
    }),
  }),
});

export default costModesService;

export const { useGetCostModesQuery } = costModesService;
